
export const border = {
  name: 'border'
}

export const borderLeft = {
  name: 'border-left'
}

export const borderLeftColor = {
  name: 'border-left-color'
}

export const borderLeftStyle = {
  name: 'border-left-style'
}

export const borderLeftWidth = {
  name: 'border-left-width'
}

export const borderRight = {
  name: 'border-right'
}

export const borderRightColor = {
  name: 'border-right-color'
}

export const borderRightStyle = {
  name: 'border-right-style'
}

export const borderRightWidth = {
  name: 'border-right-width'
}

export const borderTop = {
  name: 'border-top'
}

export const borderTopColor = {
  name: 'border-top-color'
}

export const borderTopStyle = {
  name: 'border-top-style'
}

export const borderTopWidth = {
  name: 'border-top-width'
}

export const borderBottom = {
  name: 'border-bottom'
}

export const borderBottomColor = {
  name: 'border-bottom-color'
}

export const borderBottomStyle = {
  name: 'border-bottom-style'
}

export const borderBottomWidth = {
  name: 'border-bottom-width'
}